import { Colors } from '@back-office/core';
import TextFields from '@material-ui/core/TextField';
import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PH_MOBILE_NUMBER_LENGTH } from '../../common';
import GcpBox from '../gcp-box';
import { useInvitationStyles } from '../gcp-invitaion-table';
import GcpTypography from '../gcp-typography';
import useViewModel from './viewmodel';

type GcpPhoneNumberFieldProps = {
  hiddenField: boolean;
  phoneNumberTextColor: keyof Colors;
  phoneNumber: string;
  value?: string;
  onFieldChange: (
    value: ChangeEvent<HTMLInputElement>,
    phoneNumber: string
  ) => void;
};

const GcpPhoneNumberField: FC<GcpPhoneNumberFieldProps> = ({
  hiddenField,
  phoneNumberTextColor,
  phoneNumber,
  value,
  onFieldChange,
}) => {
  const classes = useInvitationStyles();
  const { t } = useTranslation();
  const { getIsdCode, getPhoneNumberWithCode } = useViewModel(phoneNumber);

  return (
    <>
      {hiddenField ? (
        <GcpTypography paint={phoneNumberTextColor} variant="body1">
          {getPhoneNumberWithCode()}
        </GcpTypography>
      ) : (
        <GcpBox>
          <GcpBox display="flex">
            <GcpBox className={classes.isd_code}>{getIsdCode()}</GcpBox>
            <TextFields
              fullWidth
              className={classes.edited_phone}
              inputProps={{ 'aria-label': 'Without label' }}
              size="small"
              type="text"
              value={value}
              variant="outlined"
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                onFieldChange(event, phoneNumber);
              }}
            />
          </GcpBox>
          <GcpBox className={classes.validation_message}>
            {t('invite_new_user.mobile_number_validation_message', {
              mobileNumberLength: PH_MOBILE_NUMBER_LENGTH,
            })}
          </GcpBox>
        </GcpBox>
      )}
    </>
  );
};

export default GcpPhoneNumberField;
